import { ITooltipComp, ITooltipParams } from 'ag-grid-community';
import { Column } from 'ag-grid-community';
import React, { forwardRef, useImperativeHandle, useCallback } from 'react';

export interface ErrorMessageTooltipExtProps {
    errorMessage?: (rowId: string, colName: string) => string | undefined;
    warnMessage?: (data?: object) => string;
    infoMessage?: (data?: object) => string;
}

type ErrorMessageTooltipProps = ErrorMessageTooltipExtProps & ITooltipComp & ITooltipParams;

export const ColumnTooltip = forwardRef((props: ErrorMessageTooltipProps, ref) => {
    const isHeader = props.rowIndex === undefined;
    const getErrorMessage = useCallback((): string | undefined => {
        if (!isHeader) {
            const propertyName = (props.column as unknown as Column)?.getColDef().field;
            if (props.rowIndex) {
                const frontId = props.api?.getDisplayedRowAtIndex(props.rowIndex)?.data.frontId;
                if (frontId && props.errorMessage && propertyName) {
                    return props.errorMessage(frontId, propertyName);
                }
            }
        }
    }, [props.errorMessage]);

    const getWarnMessage = useCallback((): string | undefined => {
        if (!isHeader) {
            if (props.rowIndex) {
                const frontId = props.api?.getDisplayedRowAtIndex(props.rowIndex)?.data.frontId;
                if (frontId && props.warnMessage) {
                    return props.warnMessage(props.data);
                }
            }
        }
    }, [props.warnMessage]);

    const getInfoMessage = useCallback((): string | undefined => {
        if (!isHeader) {
            if (props.rowIndex) {
                const frontId = props.api?.getDisplayedRowAtIndex(props.rowIndex)?.data.frontId;
                if (frontId && props.infoMessage) {
                    return props.infoMessage(props.data);
                }
            }
        }
    }, [props.infoMessage]);

    const getTooltip = useCallback((): string | undefined => {
        if (isHeader) {
            return props.value;
        }
        return getErrorMessage() || getWarnMessage() || getInfoMessage();
    }, [getErrorMessage, getWarnMessage, getInfoMessage]);

    // AGGRID REQUIRED ------------------
    useImperativeHandle(ref, () => {
        return {
            getReactContainerClasses() {
                return ['custom-tooltip'];
            },
        };
    });
    // AGGRID REQUIRED ------------------

    return (
        <div className={`aggrid-tooltip`}>
            <span>{getTooltip()}</span>
        </div>
    );
});
